import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr0042',
    ecrans: ['00-2']
});
